/* @flow */
import { Container } from 'flux/utils';
import cx from 'classnames';
import React from 'react';
import { PromptNames } from 'constants/PromptConstants';
import PromptStore from 'stores/PromptStore';
import LeadStore from 'stores/LeadStore';
import CurrentUser from 'auth/CurrentUser';
import PromptActions from 'actions/PromptActions';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import InviteModal from 'users/components/InviteModal.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';

import './styles/HeartShare.scss';

class HeartShare extends React.Component {
  props: {
    className?: ?string,
    size?: 'large' | 'xlarge',
    color?: 'thunder' | 'pitch',
  }

  state: {
    showingBadgingHeart: boolean,
  }

  static propClasses = {
    size: {
      large: 'HeartShare-large',
      xlarge: 'HeartShare-xlarge',
    },
    color: {
      thunder: 'HeartShare-thunder',
      pitch: 'HeartShare-pitch',
    },
  }

  static defaultProps = {
    size: 'large',
    color: 'pitch',
  }

  static getStores() {
    return [PromptStore];
  }

  static calculateState() {
    return {
      showingBadgingHeart: this.shouldBadgeHeart(),
    };
  }

  static shouldBadgeHeart(): boolean {
    return !LeadStore.getLeads().isEmpty() &&
      CurrentUser.isSignedIn() &&
      CurrentUser.getUser().hasItemInPromptsInventory(PromptNames.TYMK_BADGE) &&
      !PromptStore.hasDismissed(PromptNames.TYMK_BADGE);
  }

  dismissHeartBadge = () => {
    PromptActions.recordDismissal(PromptNames.TYMK_MODAL);
    PromptActions.recordDismissal(PromptNames.TYMK_BADGE);
  }

  renderIcon() {
    const { showingBadgingHeart } = this.state;
    const className = cx({
      'HeartShare-badging': showingBadgingHeart,
    }, 'HeartShare', getPropClassesFromInstance(this), this.props.className);

    if (showingBadgingHeart) {
      return <div className={className} />;
    } else {
      return (
        <Glyph
          className={className}
          name="heart"
          size={this.props.size}
          solo
        />
      );
    }
  }

  render() {
    return (
      <ModalTrigger data-test-selector="share-remind-trigger" modal={<InviteModal />}>
        <Link eventElementName="Navigation-share" color={this.props.color} onClick={this.dismissHeartBadge}>
          {this.renderIcon()}
        </Link>
      </ModalTrigger>
    );
  }
}

export default Container.create(HeartShare, { withProps: true, pure: false });



// WEBPACK FOOTER //
// ./src/components/HeartShare.jsx